<template>
  <div class="text-start">
    <form @submit.prevent="onSubmitIssue" :class="form_class" ref="issue_form" id="issue_form" novalidate>
      <div class="row mb-3">
        <div class="col-12">
          <h5>{{ t('models.' + owner_type.toLowerCase(), 1) }} :: {{ nameOf(owner) }}</h5>
        </div>

        <div class="col-12">
          <label for="title" class="float-left mandatory">{{  t("attributes.issue.title") }}</label>
          <div class="input-group">
            <input type="text" :value="issue.title" class="form-control" name="title" :ref="setRef" @input="onUpdateFormParam" required>
            <div class="invalid-feedback text-left">{{ errorMessagesFor('title') }}</div>
          </div>
        </div>

        <div class="col-12">
          <label for="issue_category_uuid" class="float-left mandatory">{{  t("attributes.issue.issue_category") }}</label>
          <div class="input-group">
            <select name="issue_category_uuid" :ref="setRef" :value="issue.issue_category_uuid" class="form-select" @input="onUpdateFormParam" required>
              <option></option>
              <option v-for="issue_category in issue_categories" :key="issue_category.uuid" :value="issue_category.uuid">
                {{ issue_category.name }}
              </option>
            </select>
            <div class="invalid-feedback text-left">{{ errorMessagesFor('issue_category_uuid') }}</div>
          </div>
        </div>

        <div class="col-6">
          <label for="issue_severity" class="float-left mandatory">{{  t("attributes.issue.issue_severity") }}</label>
          <div class="input-group">
            <select name="issue_severity" :ref="setRef" :value="issue.issue_severity" class="form-select" @input="onUpdateFormParam" required>
              <option></option>
              <option v-for="item in issue_severities" :key="item.value" :value="item.value">
                {{ item.name }}
              </option>
            </select>
            <div class="invalid-feedback text-left">{{ errorMessagesFor('issue_severity') }}</div>
          </div>
        </div>

        <div class="col-6">
          <label for="issue_priority" class="float-left mandatory">{{  t("attributes.issue.issue_priority") }}</label>
          <div class="input-group">
            <select name="issue_priority" :ref="setRef" :value="issue.issue_priority" class="form-select" @input="onUpdateFormParam" required>
              <option></option>
              <option v-for="item in issue_priorities" :key="item.value" :value="item.value">
                {{ item.name }}
              </option>
            </select>
            <div class="invalid-feedback text-left">{{ errorMessagesFor('issue_priority') }}</div>
          </div>
        </div>

        <div class="col-6">
          <label for="due" class="float-left">{{  t("attributes.issue.due") }}</label>
          <div class="input-group">
            <input type="date" :value="issue.due" class="form-control" name="due" :ref="setRef" @input="onUpdateFormParam">
            <div class="invalid-feedback text-left">{{ errorMessagesFor('due') }}</div>
          </div>
        </div>

        <div class="col-6">
          <label for="implementation" class="float-left">{{  t("attributes.issue.implementation") }}</label>
          <div class="input-group">
            <input type="date" :value="issue.implementation" class="form-control" name="implementation" :ref="setRef" @input="onUpdateFormParam">
            <div class="invalid-feedback text-left">{{ errorMessagesFor('implementation') }}</div>
          </div>
        </div>

        <div class="col-12">
          <label for="desc" class="float-left">{{ t("attributes.issue.desc") }}</label>
          <div class="input-group">
            <textarea :value="issue.desc" class="form-control" name="desc" :ref="setRef" @input="onUpdateFormParam"/>
          </div>
        </div>

      </div>

      <div class="row mb-3 justify-content-left">
        <div class="col-12">
          <button class="btn btn-primary btn-lg btn-block float-end" type="submit" id="submit">{{ t("submit" )}}</button>
        </div>
      </div>

    </form>  
  </div>
</template>

<script>
import { ref, computed, reactive } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

import { nameOf } from '@/common/helpers';
import { setFieldValidity } from '@/common/form_field_validation'
import Constants from '@/common/constants.js'

export default {
  name: 'IssueForm',
  props: [
    "issueUuid",
    "siteUuid",
    "location",
    "asset"
  ],
  emits: [
    "issue-updated",
    "issue-created"
  ],
  setup(props, { emit }) {
    const store = useStore()
    const { t } = useI18n({ useScope: 'global' })

    const _editing_issue = reactive({})
    const site_uuid = ref(props.siteUuid)
    const form_class = ref('needs-validation')
    const issue_form = ref(null)
    const owner = reactive({})

    const owner_type = ref(null)
    const owner_uuid = ref(null)

    const issue = computed({
      get() {
        return _editing_issue.value
      },
      set(new_value) {
        _editing_issue.value = new_value
      }
    })

    if (props.issueUuid) {
      // this is a not new issue since an UUID has been generated for it
      _editing_issue.value = store.getters.getIssueByUUID(props.issueUuid)
      site_uuid.value = _editing_issue.value.site_uuid
      owner_type.value = _editing_issue.value.owner_type
      owner.value = store.getters.getObjectByUUID(_editing_issue.value.owner_type, _editing_issue.value.owner_uuid)
    } else {
      const location = ref(props.location);
      const asset = ref(props.asset);

      if (asset.value) {
        owner_type.value = "Asset";
        owner_uuid.value = asset.value.uuid;
      } else if (location.value) {
        owner_type.value = "Location";
        owner_uuid.value = location.value.uuid;        
      } else {
        owner_type.value = "Site";
        owner_uuid.value = site_uuid.value;                
      }

      owner.value = store.getters.getObjectByUUID(owner_type.value, owner_uuid.value)
      
      _editing_issue.value = {
        uuid: null,
        site_uuid: site_uuid.value,
        owner_type: owner_type.value,
        owner_uuid: owner_uuid.value,
        title: null,
        description: null
      }
    }

    console.log("Inside views/issues/Form.vue, _editing_issue.value ==> ", _editing_issue.value)

    let owner_type_lookup = {};

    const site = store.getters.getSite(site_uuid.value)
    owner_type_lookup[site.uuid] = "Site"

    const all_locations = store.getters.getLocationsBySiteUUID(site_uuid.value)
    all_locations.forEach(function(location) {
      owner_type_lookup[location.uuid] = "Location"
    });

    const all_assets = store.getters.getAssetsBySiteUUID(site_uuid.value)
    all_assets.forEach(function(asset) {
      owner_type_lookup[asset.uuid] = "Asset"
    });

    const issue_categories = store.getters.getAllIssueCategories
    const issue_priorities = Object.keys(Constants.ISSUE_PRIORITIES).reduce(function(list, item) {
      list.push({
        name: item,
        value: Constants.ISSUE_PRIORITIES[item]
      })
      return list
    }, [])
    const issue_severities = Object.keys(Constants.ISSUE_SEVERITY).reduce(function(list, item) {
      list.push({
        name: item,
        value: Constants.ISSUE_SEVERITY[item]
      })
      return list
    }, [])

    const lookupOwnerType = function(uuid) {
      return owner_type_lookup[uuid]
    }

    let _field_refs = {}
    const setRef = function(el) {
      if (el) {
        _field_refs[el.name] = el
      }
    }

    const onUpdateFormParam = function(e) {
      // update the underlying model with value from field
      const fieldName = e.target.name;
      _editing_issue.value[fieldName] = e.target.value;
      setFieldValidity(_field_refs, fieldName, null);

      console.log("Inside views/issues/Form.vue, fieldName ==> ", fieldName)

      if ((fieldName == "owner_uuid")) {
        _editing_issue.value.owner_type = lookupOwnerType(_editing_issue.value.owner_uuid);
      }
    }    

    let _form_errors = {}

    const validateForm = function(this_form) {
      _form_errors = {}

      // use the browser's checkValidity function to validate the form.
      if (!this_form.checkValidity()) {
      // then we gather the native error messages
        const inputFields = Array.from(this_form.getElementsByTagName("input")).concat(Array.from(this_form.getElementsByTagName("select")));
        inputFields.forEach(function(input) {
          const param_name = input.name
          console.log(`Inside validateForm, input.validationMessage of ${param_name} ===> `, input.validationMessage);
          if (input.validationMessage.length > 0) {
            _form_errors[param_name] = input.validationMessage;
          }
        });
      }

      console.log(`Inside validateForm, _form_errors ===> `, _form_errors);
      return isFormErrorFree(_form_errors);
    }

    const isFormErrorFree = function(form_errors) {
      return Object.values(form_errors).reduce(function(acc, val1) { 
        return ((val1 === null) || (val1.length === 0)) && acc 
      }, true);
    }

    const errorMessagesFor = function(fieldName) {
      console.log("Inside views/issues/Form.vue, errorMessagesFor() _field_refs ==> ", _field_refs)

      if (_field_refs[fieldName]) {
        return _field_refs[fieldName].validationMessage
      }
    }

    const onSubmitIssue = async function() {
      console.log("Inside issues/From.vue onSubmitIssue, issue_form.value ==> ", issue_form.value);
      if (validateForm(issue_form.value)) {
        console.log("Inside issues/From.vue onSubmitIssue, issue.value ==> ", issue.value);
        if (_editing_issue.value.uuid) {
          await store.dispatch("modifyIssue", _editing_issue.value)
          emit("issue-updated", { issueUUID: _editing_issue.value.uuid })
        } else {
          const new_issue_uuid = await store.dispatch("addIssue", _editing_issue.value)
          emit("issue-created", { issueUUID: new_issue_uuid })
        }
      } else {
        console.log("Inside issues/From.vue onSubmitIssue, validateFrom not ok");
        form_class.value = 'was-validated';
        // need this or error message may not appear
        //const instance = getCurrentInstance();
        //instance.proxy.forceUpdate();
        return;        
      }
    }

    return {
      issue,
      issue_form,
      issue_categories,
      issue_priorities,
      issue_severities,
      form_class,
      owner,
      owner_type,
      owner_uuid,
      t,
      setRef,
      onUpdateFormParam,
      errorMessagesFor,
      onSubmitIssue,
      nameOf
    }
  }
}

</script>